<template>
<v-container fluid >
    <h1 class="d-flex justify-center textTitle--text font-weight-black">{{ $t('views.clients.screenTitle') }}</h1>

    <v-card class="ma-3 pa-3 align-top primary" elevation="11">
        <v-row class="justify-center align-center">
           
        <v-select
            :items="clients"
            :item-text="'name'"
            item-value="id"
            class="pa-3 font-weight-black primary--text shrink"
            solo
            outlined
            @change="choose_client"
            background-color="quinty">
             <template v-slot:label >
                  <h2 class="primary--text">{{ $t('chooseclient.selectLabel') }}</h2>
            </template>
            </v-select>
            <v-btn @click="formNewclient_visible = true" class="mx-3 pa-3 success font-weight-black black--text">{{ $t('chooseclient.createButton') }}</v-btn>
    
    </v-row>
    </v-card>

    <v-divider class="ma-3"></v-divider> 


    <v-card 
            elevation="11"
            v-if="selectedclient_visible"
            class="pa-5 ma-3 primary">
              <v-card-title class="headline font-weight-bold textTitle--text justify-center">{{ selectedclient.name }}<v-btn v-if="selectedclient.id!='noClient'" @click="confirmdeleteclientdialog = true" class="ml-8 error font-weight-black black--text">{{ $t('delete') }}</v-btn></v-card-title>

              <v-divider></v-divider>

              
                   <v-card class="ma-5 pa-2 secondary">
                     <v-row class="justify-center align-center">
                       <v-col cols="5.5">
                          <v-row class="mx-4 justify-space-between align-center">
                       <h2 class="font-weight-bold  underline text-decoration-underline ">{{ $t('chooseclient.clientCode') }}</h2><h3 class="ml-5 font-weight-bold textMenu--text">{{selectedclient.id}}</h3>
                     </v-row>
                     <v-row class="mx-4 justify-space-between align-center">
                       <h2 class="font-weight-bold underline text-decoration-underline ">{{ $t('chooseclient.dpi') }}</h2><h3 class="ml-5 font-weight-bold textMenu--text">{{selectedclient.dpi}}</h3>
                     </v-row>
                     <v-row class="mx-4 justify-space-between align-center">
                       <h2 class="font-weight-bold text-decoration-underline">{{ $t('chooseclient.clientType') }}</h2><h3 class="ml-5 font-weight-bold textMenu--text">{{selectedclient.type}}</h3>
                     </v-row>
                     <v-row class="mx-4 justify-space-between align-center">
                       <h2 class="font-weight-bold text-decoration-underline">{{ $t('chooseclient.visitRate') }}</h2><h3 class="ml-5 font-weight-bold textMenu--text">{{selectedclient.visit_frequence}}</h3>
                     </v-row>
                       </v-col>
                       <v-divider vertical></v-divider>
                       <v-col cols="5.5">
                         <v-row class="mx-4 justify-space-between align-center">
                       <h2 class="font-weight-bold text-decoration-underline">{{ $t('chooseclient.clientTel') }}</h2><h3 class="ml-5 font-weight-bold textMenu--text">{{selectedclient.tel}}</h3>
                     </v-row>
                     <v-row class="mx-4 justify-space-between align-center">
                       <h2 class="font-weight-bold text-decoration-underline">{{ $t('chooseclient.clientTotalBuy') }}</h2><h3 class="ml-5 font-weight-bold textMenu--text">{{selectedclient.total_compra}}</h3>
                     </v-row>
                     <v-row class="mx-4 justify-space-between align-center">
                       <h2 class="font-weight-bold text-decoration-underline">{{ $t('chooseclient.clientQtyBuy') }}</h2><h3 class="ml-5 font-weight-bold textMenu--text">{{selectedclient.compras.length}}</h3>
                     </v-row>
                       </v-col>
                     </v-row>
                     


                   </v-card>
                     
                         
            </v-card>

            <v-dialog v-model="confirmdeleteclientdialog" persistent max-width="50%" :retain-focus="false">
            <v-card class="pa-5 secondary">
            <v-card class="pa-5 primary">
        <v-card-title class="headline textTitle--text font-weight-black">{{ $t('views.clients.confirmDeleteMessage') }}</v-card-title>
        <v-card-text class="text-h5 quinty--text">{{ $t('views.clients.confirmNameMessage', { '1': this.selectedclient.name }) }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error font-weightblack black--text" @click="confirmdeleteclientdialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="success font-weightblack black--text" @click="remove_client">{{ $t('confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
            </v-card>
    </v-dialog>

    
    <v-divider></v-divider>
    <v-card v-if="selectedclient.compras.length" class="ma-3 pa-5 primary" elevation="11">
    <v-data-table 
    hide-default-footer 
    dense 
    :headers="headers" 
    :items="this.compras" 
    item-key="id" 
    class="ma-3 elevation-1 quinty textTable--text font-weight-black text-h3">
    <template v-slot:[`item.fecha`]="{ item }">
    
           <span>{{new Date(item.fecha) | dateFormat('DD MMMM YYYY')}}</span>
         </template>

    </v-data-table>
    </v-card>
    
    <v-dialog v-model="formNewclient_visible" :retain-focus="false" width="80%">
      <v-card flat class="pa-5 secondary">
            <v-card  class="pa-3 primary">
<v-card-title class="headline font-weight-bold textTitle--text justify-center">{{ $t('chooseclient.newClientButton') }}</v-card-title>

              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.clientName') }}</h2>
                <v-text-field
      v-model="name"
      class="font-weight-black text-h4 ma-2 pa-2 shrink text-center"
      background-color="quinty"
      height="75px"
      rounded
    ></v-text-field>
              </v-row>
              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.dpi') }}</h2>
                <v-text-field
      v-model="dpi"
      class="font-weight-black text-h4 ma-2 pa-2 shrink text-center"
      background-color="quinty"
      height="75px"
      rounded
    ></v-text-field>
              </v-row>
              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.clientTel') }}</h2>
               <v-text-field
      v-model="tel"
      type="number"
      class="font-weight-black text-h4 ma-2 pa-2 shrink  "
      background-color="quinty"
      height="60px"
      rounded
    ></v-text-field>
              </v-row>
              
              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.clientType') }}</h2>
               <v-select
      v-model="tipo"
      :items="types"
      rounded
      class="font-weight-black text-h6 ma-2 pa-2 shrink  "
      background-color="quinty"
      height="60px"
    ></v-select>
              </v-row>
    
    
    
    <v-card-actions class="justify-center align-center ma-3 pa-3">
    <v-btn large class="ma-4 pa-3 success font-weight-black black--text" @click="save_client">{{ $t('save') }}</v-btn>
    <v-btn large class="ma-4 pa-3 error font-weight-black black--text" @click="formNewclient_visible=false">{{ $t('close') }}</v-btn>
  </v-card-actions>
            </v-card>
            </v-card>
            </v-dialog>




</v-container>
</template>

<script>
          import {mapActions} from 'vuex'
export default {
    data () {
        return {
            name:'',
            tipo:'',
            tel:'',
            dpi:'',
            compras:[],
            formNewclient_visible:false,
            selectedclient_visible:false,
            confirmdeleteclientdialog: false,
            selectedclient:{
                id:1,
                name:'',
                tel:'',
                dpi:'',
                type:'',
                visit_frequence:'',
                total_compra:0,
                compras:[],
            },
      

        }

    },
    computed:{
      types(){
      var types= [
        this.$t('clientTypes.type1'),
        this.$t('clientTypes.type2'),
        this.$t('clientTypes.type3'),
        ]
        return types
        },
      headers(){
        var headers= [
        {
          text: this.$t('headers.clientBuyId'),
          align: 'start',
          sortable: false,
          value: 'id',
          class: 'quaterny primary--text font-weight-black text-subtitle-2'
        },
        { text: this.$t('headers.clientBuyDate'), value: 'fecha',class: 'quaterny primary--text font-weight-black text-subtitle-2' },
        { text: this.$t('headers.clientBuyTotal'), value: 'total',class: 'quaterny primary--text font-weight-black text-subtitle-2' },
      ]
      return headers
      },
      clients(){
        return this.$store.state.clients
      }
    },
    methods:{
      ...mapActions([
        'addClient',
        'deleteClient'
      ]),
        save_client (){
          var id = 'client1';
            var clientdb = this.$store.state.clients;        

            if(clientdb.length>0){
               
            var size = clientdb.length
            var pos=1

            for(var i=1;i<size;i++){
              if(clientdb[i].id!=id){continue}else{
                pos+=1
                id='cat'+pos
                i=0
              }
            }
            }
            var client = {
              "id":id,
              "name":this.name,
              "tel":this.tel,
              "type":this.tipo,
              "visit_frequence":0,
              "total_compra":0,
              "compras":[],
              "dpi":this.dpi
            }

         this.addClient(client)
        this.clear_form_newclient();
        this.formNewclient_visible=false;        
      },
      remove_client (){
        this.deleteClient(this.selectedclient)
        
          this.selectedclient_visible=false;
         this.formNewclient_visible=false;
         this.confirmdeleteclientdialog = false;
      },
        choose_client (value) {
          
          const result = this.clients.find( ({ id }) => id === value );
          
          //var id = value;
            this.selectedclient=result;
            this.compras=[]
            var compra={}
            if(this.selectedclient.compras.length){
              for(var i=0;i<this.selectedclient.compras.length;i++){
                var  pos=this.$store.state.sales.map(function(e) { return e.id; }).indexOf(this.selectedclient.compras[i]);
                compra = this.$store.state.sales[pos]
                this.total_compra+=compra.total
                this.compras.push(compra)
              }
            }
            
            this.selectedclient_visible=true;
        },
        clear_form_newclient(){
            this.name = '';
            this.tel = '';
            this.tipo = '';
            this.dpi = ''
        }

    }
}
</script>
